import {useOptionalResult} from 'providers/ResultProvider'
import {ConfirmingProblem} from './ConfirmingProblem/ConfirmingProblem'
import {ThankYou} from './ThankYou/ThankYou'

export const View = () => {
  const result = useOptionalResult()

  if (!result) {
    return null
  }

  return (
    <div className="w-full d:max-w-[1256px] mx-auto px-4">
      {result.error ? (
        <ConfirmingProblem order={result.order} error={result.error} />
      ) : (
        <ThankYou order={result.order} />
      )}
    </div>
  )
}
